var Vue = require('vue');
var FundsAllocationsList = require('./components/FundsAllocationsList').default;
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');

module.exports = function() {
    const allocationsList = new Vue({
        el: '#allocations-list',
        components: {
            'allocations-list': FundsAllocationsList
        }
    });

    $(document).one('pjax:end', () => {
        allocationsList.$destroy();
    });
    new Columnator();
    new IndexView();
};
